export default {
  siteName:'P.M.S.',
  header:{
    breadcrumb:{
      FrontPage:'Home'
    },
    tooltip:{
      Screenfull:'Screenfull',
      wireless:'Wireless Transmission',
      Sketch:'Sketch',
      Mindmap:'Mindmap',
      Language:'Language',
      Excel:'Excel'
    },
    dropdown:{
      CN:'CN',
      EN:'EN',
      Logout:'Logout',
      Password:'Password',
    }
  },
  searchBox:{
    Placeholder_1:'Please input keyworks...',
    Placeholder_2:'Category',
    Message_1:'Please select category first!',
    Message_2:'keys or value should not be empty!'
  },
  selector:{
    Category:{
      Placeholder:'Please select category...',
    }
  },
  tags:{
    name:'tags'
  },
  route: {
    Quality:'Quality',
    HSE:'HSE',
    MarketInfo:'MarketInfo',
    Collaboration:'Collaboration',
    Email:'EmailBox',
    Cost:'Cost',
    Location:'Location',
    Invoice:'Invoice',
    Organization:'Organization',
    Office:'OfficeTemplate',
    CloudBucket:'CloudBucket',
    Procurement:'Procurement',
    Storage:'Storage',
    Administration:'Administration',
    Information:'Information',
    Tools:'Tools',
    Settings:'Settings',
    FrontPage:'FrontPage',
    Dashboard:'Dashboard',
    Scheduler:'Scheduler',
    Customer:'Customer',
    GoodsList:'GoodsList',
    ContactList:'ContactList',
    401:'401',
    Password:'Password',
    Sketch:'Sketch',
    Mindmap:'Mindmap',
    Chat:'Chat'
  },
  tagsView: {
    CloseAll: 'Close All'
  },
  buttons:{
    Add:'Add',
    AddTemp:'New Template',
    ImportExcel:'Import Excel',
    ExportExcel:'Export Excel',
    Import:'Import',
    Export:'Export',
    BatchDelete:'Batch Delete',
    UploadFile:'Upload File',
    BatchDownload:'Batch Download',
    Operation:'Operation',
    Preview:'Preview',
    Public:'Public',
    Private:'Private',
    Download:'Download',
    Edit:'Edit',
    Delete:'Delete',
    Submit:'Submit',
    Cancel:'Cancel',
    Confirm:'Confirm',
    Publish:'Publish',
    WithDraw:'WithDraw',
    Close:'Close',
    Print:'Print'
  },
  noticeMessage:{
    SaveSuccess:'Save Success',
    UploadSucess:' Upload Sucess!',
    ModifySuccess:'Modify Success',
    DeleteSuccess:'Delete Success',
    TipContent:'Are you sure want to delete',
    Tips:'Tips',
    SubmitErr:'Failed to submit, incomplete form',
    BatchSelect:'Please Select Items First',
    BatchDelete:'Are you sure want to delete selected items',
    UnSelect:'Please select item first'
  },
  quality:{
    tabTitle:{
      ITP:'ITP',
      Supervision:'Supervision',
      Record:'Record'
    }
  },
  task:{
    tabTitle:{
      Scheduler:'MySchedule',
      GanttChart:'MyPlan',
    }
  },
  hse:{
    tabTitle:{
      JSA:'JSA',
      Record:'Record',
      WorkPermit:'WorkPermit',
      Report:'Report'
    }
  },
  cloudBucket:{
      Item:'Item',
      FileName:'FileName',
      FileType:'FileType',
      FileSize:'FileSize',
      FolderName:'FolderName',
      Creator:'Creator',
      CreateTime:'CreateTime',
      IsPublic:'IsPublic',
      Operation:'Operation',
  },
  office:{
      Excel:'ExcelTemplate',
      ID:'ID',
      Item:'Item',
      FileName:'FileName',
      Creator:'Creator',
      CreateTime:'CreateTime',
      Operation:'Operation',
      Back:'Back',
      Save:'Save Data',
      Loading:'Loading...',
      SelectTemp:'Please select template'
  },
  procurement:{
    Inquiry:'Inquiry',
    ID:'ID',
    Item:'Item',
    Name:'Name',
    Creator:'Creator',
    CreateTime:'CreateTime',
    Operation:'Operation',
},
  adminHR:{
    tabTitle:{
      Personnel:'Personnel',
      Asset:'Asset',
      Meeting:'Meeting',
      Vehicle:'Vehicle',
    },
    table:{
      Item:'Item',
      Name:'Name',
      Creator:'Creator',
      CreateTime:'CreateTime',
      Operation:'Operation',
    }
  },
  information:{
    tabTitle:{
      News:'News',
      Notice:'Notice',
      DailyReport:'DailyReport',
      BBS:'BBS'
    },
    table:{
      Item:'Item',
      Title:'Title',
      Creator:'Creator',
      CreateTime:'CreateTime',
      Status:'Status',
      Operation:'Operation',
      Content:'Content',
      Published:'Published',
      Ready:'Ready',
      Avatar:'Avatar',
      IsSwiper:'IsSwiper'
    },
    dialog:{
      Edit:'Edit',
      Editor:'Editor',
      NewAdd:'NewAdd',
      NoticeTitle:'NoticeTitle',
      NewsTitle:'NewsTitle',
      DailyReport:'DailyReport',
      Placeholder_1:'Please Input Title',
      Placeholder_2:'Please Input Content',
    }
  },
  contact:{
    Name:'Name',
    Tag:'Tag',
    Company:'Company',
    Department:'Department',
    Position:'Position',
    Phone:'Phone',
    Address:'Address',
    Email:'Email',
    ShareList:'ShareList',
    Creator: ' Creator',
    CreateTime: 'CreateTime',
    Operation:'Operation',
    Item:'Item',
    Edit:'Edit Item',
    NewAdd:'New Item',
    AddPhone:'AddPhone',
    dialog:{
      Placeholder_1:'Please input name',
      Placeholder_2:'Please input company',
      Placeholder_3:'please input department',
      Placeholder_4:'Please input position',
      Placeholder_5:'Please input phone number',
      Placeholder_6:'Please input contact address',
      Placeholder_7:'Please input email',
      Placeholder_8:'Please select sharedList',
    }
  },
  customer:{
    Avatar:'Logo',
    Name:'Name',
    EstablishedDate:'EstablishedDate',
    LegalPerson:'LegalPerson',
    Industry:'Industry',
    SeniorExecutive:'SeniorExecutive',
    RegisteredCapital:'RegisteredCapital',
    RegisteredAddress:'RegisteredAddress',
    ContributedCapital:'ContributedCapital',
    Shareholder:'Shareholder',
    BusinessScope:'BusinessScope',
    ContactPerson:'ContactPerson',
    ContactPhone:'ContactPhone',
    ContactAddress:'ContactAddress',
    ContactEmail:'ContactEmail',
    Website:'Website',
    Remark:'Remark',
    Tag:'Tag',
    Creator: ' Creator',
    CreateTime: 'CreateTime',
    Operation:'Operation',
    Item:'Item',
    Edit:'Edit Item',
    NewAdd:'New Item',
    Relationship:'Relationship',
    tabPane:{
      Title_1:'Basic Info',
      Title_2:'Shareholder Info',
      Title_3:'Contact Info',
      SubTitle_1:'Add Shareholder Info',
      SubTitle_2:'Add Senior Executive Info',
    },
    dialog:{
      Placeholder_1:'Please input customer name',
      Placeholder_2:'Please input established date',
      Placeholder_3:'Please input legal person',
      Placeholder_4:'Please input registered capital',
      Placeholder_5:'Please input contributed capital',
      Placeholder_6:'Please input registered address',
      Placeholder_7:'Please input shareholder name',
      Placeholder_8:'Please input share ratio(%)',
      Placeholder_9:'Please input senior executive title',
      Placeholder_10:'Please input senior executive name',
      Placeholder_11:'Please input business Scope',
      Placeholder_12:'Please input contact person',
      Placeholder_13:'Please input contact phone',
      Placeholder_14:'Please input contact address',
      Placeholder_15:'Please input contact email',
      Placeholder_16:'Please input website',
      Placeholder_17:'Please input remark',
      Placeholder_18:'Please select relationship',
    },
    relationshipOptions:{
      option_1:'Potential Customer',
      option_2:'Regular Customer',
      option_3:'Ordinary Customer',
      option_4:'key Account'
    }
  },

  goodslist:{
      Creator:'Creator',
      CreateTime:'CreateTime',
      Operation:'Operation',
      Item:'Item',
      Edit:'Edit Item',
      NewAdd:'New Item',
      Remark:'Remark',
      RemarkPlaceholder:'Please input remark',
      ID:'ID',
      Avatar:'Picture',
      Description:'Description',
      AlarmLower:'AlarmLower',
      MeasureUnit:'MeasureUnit',
      Tag:'Tag',
      Name:'Name',
      Spec:'Specification',
      Category:'Category',
      QRcode:'QRcode',
      dialog:{
        Placeholder_1:'Please input description of the goods',
        Placeholder_2:'Please set the low stock alert values',
      },
      rules:{
        Placeholder_1:'Please input goods name',
        Placeholder_2:'Please input goods ID',
        Placeholder_3:'Please select goods category',
        Placeholder_4:'Please input goods specification',
        Placeholder_5:'Please select measure unit',
      }
  },
  storage:{
    Warehouse:'Warehouse',
    StockIn:'StockIn',
    StockOut:'StockOut',
    Stock:'Stock',
    Creator:'Creator',
    CreateTime:'CreateTime',
    Operation:'Operation',
    Item:'Item',
    Edit:'Edit Item',
    NewAdd:'New Item',
    Remark:'Remark',
    RemarkPlaceholder:'Please input remark',
    warehouse:{
      ID:'ID',
      Name:'Name',
      Placeholder_1:'Please input warehouse name',
    }
  },
  settings:{
    tabTitle:{
      OperationLog:'OperationLog',
      Category:'Category',
      AdminUser:'AdminUser',
      Permission:'Permission',
      Icon:'Icon',
      IconFont:'IconFont',
      ElementUI:'ElementUI'
    },
    table:{
      //log
      Item:'Item',
      Avatar:'Avatar',
      UserName:'UserName',
      NickName:'NickName',
      OperationTime:'OperationTime',
      //category
      ParentName:'ParentName',
      ChildName:'ChildName',
      Operation:'Operation',
      Creator:'Creator',
      CreateTime:'CreateTime',
      //adminuser
      Role:'RoleName',
      Password:'Password',
      Description:'Description',
      RoleSetting:'RoleSetting'
    },
    dialog:{
      Edit:'Edit',
      NewAdd:'NewAdd',
      Placeholder_1:'Please Select ParentName',
      Placeholder_2:'Please Select ChildName',
      Placeholder_3:'Please Input MenuName',
      Placeholder_4:'Please Input MenuTag',
      Placeholder_5:'Please Input MenuPath',
      Placeholder_6:'Please Input MenuIcon',
      Placeholder_7:'Please Input UserName',
      Placeholder_8:'Please Input NickName',
      Placeholder_9:'Please Input Password',
      Placeholder_10:'Please Input RoleName',
    }
  },
  login:{
    Title:'P.M.S',
    Confirm:'Confirm',
    Placeholder_1:'UserName',
    Placeholder_2:'Password',
  },
}
